import { render, staticRenderFns } from "./AddEditSpecimensDesc.vue?vue&type=template&id=70e93e6e&scoped=true"
import script from "./AddEditSpecimensDesc.vue?vue&type=script&lang=js"
export * from "./AddEditSpecimensDesc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70e93e6e",
  null
  
)

export default component.exports